import React from 'react'
import { MdWarning } from '@react-icons/all-files/md/MdWarning'
import { Callout } from 'components/ds'
type Props = {
  children: React.ReactNode
  testId?: string
}

/**
 * Warning component for displaying error messages and alerts in login forms
 * Red-colored callout with warning icon for error states and important messages
 * @param children - Content to display within the warning callout
 * @param testId - Optional data-testid forwarded to the callout root for E2E tests
 */
const Warning = ({ children, testId }: Props): React.ReactNode => (
  <Callout.Root color="red" data-testid={testId}>
    <Callout.Icon>
      <MdWarning />
    </Callout.Icon>
    <Callout.Text>{children}</Callout.Text>
  </Callout.Root>
)

export default Warning
